import React from 'react';
import { Box, Link, Paper, Typography } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';
import { GreeningAgentSignature } from './greening/GreeningAgentSignature';

export interface ChangeEmailPreviewData {
  headline: string;
  title: string;
  summary: string;
  document_url: string;
  intro: string;
  marketing_signature: string;
  state?: string;
  agency?: string;
  change_type?: string;
}

interface ChangeEmailPreviewProps {
  preview: ChangeEmailPreviewData | null;
  loading?: boolean;
}

function MarketingSignature() {
  return <GreeningAgentSignature />;
}

export function ChangeEmailPreview({ preview, loading }: ChangeEmailPreviewProps) {
  const theme = useTheme();

  if (loading) {
    return (
      <Typography variant="body2" color="text.secondary">
        Carregando prévia…
      </Typography>
    );
  }

  if (!preview) return null;

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        bgcolor: alpha(theme.palette.primary.main, 0.05),
        border: `1px solid ${theme.palette.divider}`,
      }}
    >
      <Typography variant="caption" color="text.secondary" display="block" mb={1}>
        Prévia do conteúdo
      </Typography>
      <Typography variant="body2" color="text.secondary" gutterBottom>
        {preview.intro}
      </Typography>
      <Typography variant="body2" fontWeight={600} gutterBottom>
        <Link href={preview.document_url} target="_blank" rel="noopener noreferrer" underline="hover">
          {preview.headline}
        </Link>
        {preview.state ? ` — ${preview.state}` : ''}
      </Typography>
      <Typography variant="body2" color="text.secondary" gutterBottom>
        {preview.title}
      </Typography>
      {preview.summary && (
        <Typography variant="body2" sx={{ mt: 1 }}>
          <strong>Resumo:</strong> {preview.summary}
        </Typography>
      )}
      {(preview.agency || preview.change_type) && (
        <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 1 }}>
          {preview.agency ? `Agência: ${preview.agency}` : ''}
          {preview.agency && preview.change_type ? ' • ' : ''}
          {preview.change_type ? `Tipo: ${preview.change_type}` : ''}
        </Typography>
      )}
      <Box sx={{ mt: 2, pt: 1.5, borderTop: 1, borderColor: 'divider' }}>
        <Typography variant="caption" color="text.secondary" fontStyle="italic" component="div">
          <MarketingSignature />
        </Typography>
      </Box>
    </Paper>
  );
}
